import React from 'react';
import { motion } from 'framer-motion';
import { fadeUp } from '../../utils/motion';
export type Topic = {
  title: string;
  paragraphs: string[];
};
type TopicIndexProps = {
  topics: Topic[];
  indexLabel: string;
};
function toId(title: string) {
  return title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
}
export function TopicIndex({
  topics,
  indexLabel
}: TopicIndexProps) {
  const scrollTo = (id: string) => (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    document.getElementById(id)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <section className="bg-white py-20 lg:py-28" data-id="element-641" data-mp="2yj69cd90f1qk">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-642" data-mp="2tr6g13ng372y">
        <nav aria-label={indexLabel} className="hidden lg:block lg:col-span-4" data-id="element-643" data-mp="260snzd4v188d">
          <div className="sticky top-28" data-id="element-644" data-mp="212hb0tj9qhlx">
            <p className="text-sm font-medium text-ink-muted mb-4" data-id="element-645" data-mp="211g0qra2tz59">{indexLabel}</p>
            <ul className="border-l border-line" data-id="element-646" data-mp="zdr422vltufj">
              {topics.map(topic => <li key={topic.title} data-id="element-647" data-mp="13drktu66ehpr">
                  <a href={`#${toId(topic.title)}`} onClick={scrollTo(toId(topic.title))} className="block -ml-px border-l-2 border-transparent hover:border-navy pl-4 py-1.5 text-sm text-ink-muted hover:text-navy transition-colors duration-150" data-id="element-648" data-mp="13cq9dol8zt7i">
                    {topic.title}
                  </a>
                </li>)}
            </ul>
          </div>
        </nav>

        <div className="lg:col-span-8" data-id="element-649" data-mp="peiernbop3zi">
          {topics.map(topic => <motion.article key={topic.title} id={toId(topic.title)} {...fadeUp} className="scroll-mt-28 border-t border-line py-12 first:border-t-0 first:pt-0" data-id="element-650" data-mp="udlcempc47xg">
              <h2 className="font-heading font-bold text-2xl lg:text-3xl text-ink-dark tracking-tight mb-5" data-id="element-651" data-mp="25rywrhkvq58q">
                {topic.title}
              </h2>
              <div className="space-y-4" data-id="element-652" data-mp="1b5ta3rii3lce">
                {topic.paragraphs.map(paragraph => <p key={paragraph} className="text-lg text-ink-muted leading-relaxed" data-id="element-653" data-mp="1q3230pngcx68">
                    {paragraph}
                  </p>)}
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}